<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-tabs v-model="activeTab" @tab-click="handleClick">
                <!--<el-tab-pane label="上传日志" name="zj_log"></el-tab-pane>-->
                <el-tab-pane label="下载日志" name="down_log">
                    <!--<el-tabs v-model="activeTab" @tab-click="handleClick">-->
                    <!--<el-tab-pane label="资源中心" name="resource_center"></el-tab-pane>-->
                    <!--<el-tab-pane label="集体备课" name="beike"></el-tab-pane>-->
                    <!--<el-tab-pane label="实验演示" name="exp_show"></el-tab-pane>-->
                    <!--</el-tabs>-->
                </el-tab-pane>
            </el-tabs>
            <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                <el-form-item label="学段/学科筛选">
                    <el-select size="small" v-model="searcherModel.xd" placeholder="请选择">
                        <el-option v-for="(item, key) in xd" :key="key" :label="item" :value="key">
                        </el-option>
                    </el-select>
                    <el-select size="small" v-model="searcherModel.chid" placeholder="请选择">
                        <el-option v-for="(item, key) in subjects" :key="item.subject_id" :label="item.subject_name"
                                   :value="item.subject_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间筛选">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.time"
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="高级筛选(不支持模糊搜索)">
                    <el-input placeholder="请输入内容" v-model="searcherModel.advance_filter_content"
                              class="input-with-select">
                        <el-select style="width: 118px" v-model="searcherModel.advance_filter_type" slot="prepend"
                                   placeholder="请选择">
                            <el-option v-for="(item, key) in advance_filters" :key="key" :label="item" :value="key">
                            </el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="success" @click="exportLog">导出Excel(最多导出10000条)</el-button>
                    <el-button type="primary" size="small" @click="submitSearch" icon="el-icon-search">搜索</el-button>
                    <el-button size="small" @click="resetForm()">重置</el-button>
                </el-form-item>
            </el-form>
            <!--组卷日志-->
            <!--div v-if="activeTab=='down_log'">共消耗<span style="color: #ff0000">{{coin_sum}}</span>个学币</div-->
            <el-table :data="list" style="width: 100%" v-loading="loading"
                      class="scrollbar tabTopBorder order-tab-list" :key="activeTab">
                <el-table-column label="资料ID" prop="asset_id"></el-table-column>
                <el-table-column label="资料标题" prop="title"></el-table-column>
                <el-table-column label="学段学科">
                    <template slot-scope="scope">
                        {{xd[scope.row.stage]}}/
                        <span v-for="item in subjects">
                            <span v-if="item.subject_id == scope.row.subject_id ">
                                {{item.subject_name}}
                            </span>
                    </span>
                    </template>
                </el-table-column>
                <el-table-column label="类型" prop="asset_type_name"></el-table-column>
                <el-table-column label="下载时间" prop="created_at"></el-table-column>
                <el-table-column label="真实姓名" prop="real_name"></el-table-column>
                <el-table-column label="下载人" prop="username"></el-table-column>
                <el-table-column label="下载人ID" prop="uid"></el-table-column>
                <el-table-column label="所属学校" prop="customer_name"></el-table-column>
                <el-table-column label="所属学校ID" prop="customer_id"></el-table-column>
                <el-table-column label="下载IP" prop="ip"></el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>
        </div>
    </div>
</template>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import Log from "~/services/log";
    import Params from "~/config/params";
    import Function from '~/common/functions'



    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                activeTab: 'down_log',
                xd: {
                    1: '小学',
                    2: '初中',
                    3: '高中',
                },
                advance_filters: {
                    0: '请选中',
                    1: '下载人',
                    2: '下载人ID',
                    3: '学校名称',
                    4: '学校名称ID',
                },
                subjects: [],
                types: {
                    0: "普",
                    1: "精",
                    2: "特",
                    3: "资源包",
                },
                searcherModel: {
                    xd: '',
                    chid: '',
                    paperfrom: '',
                    usertype: '',
                    advance_filter_type: '',
                    advance_filter_content: '',
                    time: [],
                },
                list: [],
                coin_sum: '',
                point_sum: '',
                loading: true,
                // 分页信息
                linkPage: null
            };
        },
        watch: {
            activeTab(d, v) {
                this.activeTab = d;
            }
        },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.searcherModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.initData(params);
        },
        created: function () {
            this.initData();
            this.subjects = Params.getSubjects();
        },
        methods: {
            down_count(params = {}) {
                Log.zj_down_count_point(params).then(res => {
                    this.coin_sum = res.data['coin_sum'];
                    this.point_sum = res.data['point_sum'];
                });
            },
            watchPageChange(pageParams) {
                this.loading = true;
                let params = this.searcherModel;
                params['page'] = pageParams["page"];
                params['perPage'] = pageParams["perPage"];
                params['stage'] = this.searcherModel.xd;
                params['subject_id'] = this.searcherModel.chid;
                if(this.searcherModel.time.length>0){
                    params['start_at'] = this.searcherModel.time[0]/1000;
                    params['end_at'] = this.searcherModel.time[1]/1000+86399;
                }
                this.initData(params);
            },
            handleClick(tab) {
                this.searcherModel = {};
                this.list = [];
                this.loading = true;
                if (this.activeTab == 'work_log') {
                    this.advance_filters = this.work_advance_filters;
                }
                this.initData();
            },
            initData(params = {}) {
                //参数转换
                if(params['advance_filter_type'] == 1) {
                    params['username'] = this.searcherModel.advance_filter_content;
                }else if(params['advance_filter_type'] == 3){
                    params['customer_name'] = this.searcherModel.advance_filter_content;
                }else if(params['advance_filter_type'] == 2){
                    params['uid'] = this.searcherModel.advance_filter_content;
                }else if(params['advance_filter_type'] == 4){
                    params['customer_id'] = this.searcherModel.advance_filter_content;
                }
                let fetch = '';
                if (this.activeTab == 'down_log') {
                    fetch = Log.jb3_down_log(params);
                }
                fetch.then(res => {
                    if(res.data == null){
                        this.linkPage = null
                    }
                    this.loading = false;
                    this.list = res.data;
                    if(res.data.length>0){
                        this.coin_sum = _.first(res.data)['coins'];
                    }
                    this.linkPage = res._meta;
                });
            },
            // 筛选查询
            submitSearch() {
                // loading 动画
                this.loading = true;
                let params = {
                    stage: this.searcherModel.xd,
                    subject_id: this.searcherModel.chid,
                    advance_filter_type: this.searcherModel.advance_filter_type,
                    advance_filter_content: this.searcherModel.advance_filter_content,
                }
                if(this.searcherModel.time && this.searcherModel.time.length>0){
                    params['start_at'] = this.searcherModel.time[0]/1000;
                    params['end_at'] = this.searcherModel.time[1]/1000+86399;
                }
                this.initData(params);
            },
            // 重置筛选表单
            resetForm() {
                this.searcherModel = _.clone(_.extend(this.searcherModel, {
                    xd: '',
                    chid: '',
                    time: [],
                    advance_filter_type:'',
                    advance_filter_content: '',
                }));
                this.initData();
            },
            exportLog() {
                let params = {
                    stage: this.searcherModel.xd,
                    subject_id: this.searcherModel.chid,
                    advance_filter_type: this.searcherModel.advance_filter_type,
                    advance_filter_content: this.searcherModel.advance_filter_content,
                }
                if(this.searcherModel.time && this.searcherModel.time.length>0){
                    params['start_at'] = this.searcherModel.time[0]/1000;
                    params['end_at'] = this.searcherModel.time[1]/1000+86399;
                }
                this.initData(params);
                let url = 'https://scrm.21cnjy.net/product/jb3/export';
                Function.exportFile(url, params);
                return false;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/log/jb3.vue